/* ============================================================
   FrikiManiaMerch — tema Shopify
   Carrito Ajax real (usa /cart/add.js, /cart.js, /cart/change.js
   de Shopify) + drawer lateral + checkout nativo de Shopify.
   ============================================================ */

function showToast(msg){
  var el = document.getElementById("toast");
  if(!el) return;
  document.getElementById("toastMsg").textContent = msg;
  el.classList.add("show");
  clearTimeout(showToast._t);
  showToast._t = setTimeout(function(){ el.classList.remove("show"); }, 2400);
}

function updateCartCount(count){
  document.querySelectorAll("[data-cart-count]").forEach(function(el){ el.textContent = count; });
}

function cartItemRowHTML(item){
  var img = item.image
    ? '<img src="' + item.image + '&width=100" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">'
    : '';
  var variant = (item.variant_title && item.variant_title !== 'Default Title') ? ' — ' + item.variant_title : '';
  return (
    '<div class="cart-item" data-key="' + item.key + '">' +
      '<div class="thumb">' + img + '</div>' +
      '<div class="info">' +
        '<h4>' + item.product_title + variant + '</h4>' +
        '<div class="qty-row">' +
          '<button type="button" data-qty-dec="' + item.key + '">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty-inc="' + item.key + '">+</button>' +
          '<a href="#" class="remove-link" data-qty-remove="' + item.key + '">' + (window.FM_I18N.remove) + '</a>' +
        '</div>' +
      '</div>' +
      '<div class="item-price"><span class="price-amount" data-price-cents="' + item.final_line_price + '">' + formatMoney(item.final_line_price) + '</span></div>' +
    '</div>'
  );
}

function formatMoney(cents){
  // Usa el formato de moneda activo de la tienda (ya localizado por Shopify)
  try{
    return window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(cents, window.FM_MONEY_FORMAT) : (cents/100).toFixed(2);
  }catch(e){
    return (cents/100).toFixed(2);
  }
}

function renderCartDrawer(cart){
  var body = document.getElementById("cartDrawerBody");
  var foot = document.getElementById("cartDrawerFoot");
  if(!body) return;
  if(cart.item_count === 0){
    body.innerHTML =
      '<div class="empty-cart">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
        '<p style="font-weight:700;margin-bottom:6px;">' + window.FM_I18N.cartEmpty + '</p>' +
        '<p style="font-size:12.5px;">' + window.FM_I18N.cartEmptySub + '</p>' +
      '</div>';
    foot.innerHTML = '';
    return;
  }
  body.innerHTML = cart.items.map(cartItemRowHTML).join("");
  foot.innerHTML =
    '<div class="total-row grand"><span>' + window.FM_I18N.total + '</span><span class="price-amount" data-price-cents="' + cart.total_price + '">' + formatMoney(cart.total_price) + '</span></div>' +
    '<a href="' + window.FM_ROUTES.cart_url + '" class="btn btn-ghost btn-full" style="margin-bottom:10px;">' + window.FM_I18N.viewCart + '</a>' +
    '<a href="/checkout" class="btn btn-primary btn-full">' + window.FM_I18N.checkout + '</a>';
  applyCurrency();

  body.querySelectorAll("[data-qty-inc],[data-qty-dec],[data-qty-remove]").forEach(function(el){
    el.addEventListener("click", function(e){
      e.preventDefault();
      var key = el.dataset.qtyInc || el.dataset.qtyDec || el.dataset.qtyRemove;
      var current = cart.items.find(function(i){ return i.key === key; });
      var qty = el.dataset.qtyRemove !== undefined ? 0 : (el.dataset.qtyInc !== undefined ? current.quantity + 1 : current.quantity - 1);
      changeCartItem(key, qty);
    });
  });
}

function fetchCart(){
  return fetch("/cart.js").then(function(r){ return r.json(); });
}

function refreshCart(){
  fetchCart().then(function(cart){
    updateCartCount(cart.item_count);
    renderCartDrawer(cart);
  });
}

function addToCart(variantId, qty){
  qty = qty || 1;
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
  })
  .then(function(r){ if(!r.ok) throw new Error("add failed"); return r.json(); })
  .then(function(){
    showToast(window.FM_I18N.added);
    refreshCart();
    openCartDrawer();
  })
  .catch(function(){ showToast(window.FM_I18N.addError); });
}

function changeCartItem(key, qty){
  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r){ return r.json(); })
  .then(function(cart){
    updateCartCount(cart.item_count);
    renderCartDrawer(cart);
  });
}

function openCartDrawer(){
  var overlay = document.getElementById("cartOverlay");
  var drawer = document.getElementById("cartDrawer");
  if(!drawer) return;
  overlay.classList.add("show");
  drawer.classList.add("show");
}
function closeCartDrawer(){
  var overlay = document.getElementById("cartOverlay");
  var drawer = document.getElementById("cartDrawer");
  if(!drawer) return;
  overlay.classList.remove("show");
  drawer.classList.remove("show");
}

document.addEventListener("DOMContentLoaded", function(){
  // Defaults de i18n/rutas por si el layout no los definió todavía
  window.FM_I18N = window.FM_I18N || { added:"Añadido al carrito", addError:"No se pudo añadir", cartEmpty:"Tu carrito está vacío", cartEmptySub:"Añade productos del catálogo", total:"Total", viewCart:"Ver carrito", checkout:"Ir a pagar", remove:"Eliminar" };
  window.FM_ROUTES = window.FM_ROUTES || { cart_url:"/cart" };

  document.getElementById("cartToggle") && document.getElementById("cartToggle").addEventListener("click", function(){
    refreshCart();
    openCartDrawer();
  });
  document.getElementById("cartClose") && document.getElementById("cartClose").addEventListener("click", closeCartDrawer);
  document.getElementById("cartOverlay") && document.getElementById("cartOverlay").addEventListener("click", closeCartDrawer);

  // Botones "Añadir al carrito" (tarjetas de producto)
  document.body.addEventListener("click", function(e){
    var btn = e.target.closest("[data-add-to-cart]");
    if(!btn) return;
    if(btn.type === "submit") return; // el formulario de producto ya hace su propio submit interceptado abajo
    e.preventDefault();
    addToCart(btn.dataset.variantId, 1);
  });

  // Formulario de producto (página de producto, con variantes)
  var pf = document.getElementById("ProductForm");
  if(pf){
    pf.addEventListener("submit", function(e){
      e.preventDefault();
      var variantId = document.getElementById("ProductVariantId").value;
      addToCart(variantId, 1);
    });
  }

  refreshCart();
  initCurrencyToggle();
  initLanguageToggle();
  initGeoRestriction();
});

/* ============================================================
   Restricción por país: la categoría "Armas" (handle "armas")
   solo se muestra a visitantes con IP de España. El resto de
   categorías (Llaveros incluido) se ven siempre, en todo el
   mundo. Como el tema no tiene Shopify Markets activado, esto
   se resuelve consultando un servicio externo de geolocalización
   por IP desde el navegador del visitante (no desde aquí).
   Si el servicio falla o no responde, se oculta por defecto
   (opción más segura).
   ============================================================ */
function initGeoRestriction(){
  var restricted = document.querySelectorAll('[data-geo-restrict="ES"]');
  if(restricted.length === 0) return; // no hay bloque "Armas" en esta página

  // Página de la propia colección "Armas": si no es España, redirige al catálogo.
  var onArmasPage = /\/collections\/armas(\/|$)/.test(location.pathname);

  fetch("https://ipapi.co/json/")
    .then(function(r){ return r.json(); })
    .then(function(data){
      if(data && data.country_code === "ES"){
        restricted.forEach(function(el){ el.style.display = ""; });
      } else if(onArmasPage){
        location.href = "/collections/all";
      }
    })
    .catch(function(){
      if(onArmasPage) location.href = "/collections/all";
      // si falla la consulta, los chips/tiles se quedan ocultos (ya lo están por defecto)
    });
}

/* ============================================================
   Selector de moneda (EUR / USD / CAD) — conversión con tasas
   fijas a partir de la moneda real de la tienda (Shopify cobra
   siempre en esa moneda; esto es solo para mostrar un precio
   de referencia). Se guarda la elección en localStorage.
   ============================================================ */
var FM_CURR_KEY = "fm_currency";
var FM_RATES_FROM_USD = { USD: 1, EUR: 0.92, CAD: 1.37 };
var FM_SYMBOLS = { USD: "$", EUR: "€", CAD: "CA$" };

function fmGetShopCurrency(){
  return (window.FM_SHOP_CURRENCY || "USD").toUpperCase();
}
function fmRateFromShopCurrency(target){
  var shopCur = fmGetShopCurrency();
  // Tasas están definidas partiendo de USD; si la tienda no cobra en USD, primero pasamos por USD.
  var toUSD = shopCur === "USD" ? 1 : (1 / (FM_RATES_FROM_USD[shopCur] || 1));
  var usdToTarget = FM_RATES_FROM_USD[target] || 1;
  return toUSD * usdToTarget;
}
function fmFormatPrice(cents, currency){
  var rate = fmRateFromShopCurrency(currency);
  var amount = ((cents / 100) * rate).toFixed(2);
  var symbol = FM_SYMBOLS[currency] || currency;
  return amount + " " + symbol;
}
function getCurrentCurrency(){
  return localStorage.getItem(FM_CURR_KEY) || "EUR";
}
function applyCurrency(){
  var curr = getCurrentCurrency();
  document.querySelectorAll("[data-price-cents]").forEach(function(el){
    var cents = parseFloat(el.getAttribute("data-price-cents"));
    if(isNaN(cents)) return;
    el.textContent = fmFormatPrice(cents, curr);
  });
  document.querySelectorAll("#currToggle button").forEach(function(btn){
    btn.classList.toggle("active", btn.dataset.curr === curr);
  });
}
function initCurrencyToggle(){
  var wrap = document.getElementById("currToggle");
  if(!wrap) { applyCurrency(); return; }
  wrap.querySelectorAll("button[data-curr]").forEach(function(btn){
    btn.addEventListener("click", function(){
      localStorage.setItem(FM_CURR_KEY, btn.dataset.curr);
      applyCurrency();
    });
  });
  applyCurrency();
}

/* ============================================================
   Selector de idioma (ES / EN) — funciona sin depender de que
   la tienda tenga varios idiomas activados en Shopify. Cambia
   el texto de cualquier elemento con data-i18n-en (guardando el
   español original la primera vez) y guarda la elección.
   ============================================================ */
var FM_LANG_KEY = "fm_language";
function getCurrentLanguage(){
  return localStorage.getItem(FM_LANG_KEY) || "es";
}
function applyLanguage(){
  var lang = getCurrentLanguage();
  document.querySelectorAll("[data-i18n-en]").forEach(function(el){
    if(!el.dataset.i18nEs) el.dataset.i18nEs = el.textContent;
    el.textContent = lang === "en" ? el.getAttribute("data-i18n-en") : el.dataset.i18nEs;
  });
  document.querySelectorAll("[data-i18n-en-placeholder]").forEach(function(el){
    if(!el.dataset.i18nEsPlaceholder) el.dataset.i18nEsPlaceholder = el.getAttribute("placeholder");
    el.setAttribute("placeholder", lang === "en" ? el.getAttribute("data-i18n-en-placeholder") : el.dataset.i18nEsPlaceholder);
  });
  document.documentElement.lang = lang;
  document.querySelectorAll("#langToggle button").forEach(function(btn){
    btn.classList.toggle("active", btn.dataset.lang === lang);
  });
}
function initLanguageToggle(){
  var wrap = document.getElementById("langToggle");
  if(!wrap) { applyLanguage(); return; }
  wrap.querySelectorAll("button[data-lang]").forEach(function(btn){
    btn.addEventListener("click", function(){
      localStorage.setItem(FM_LANG_KEY, btn.dataset.lang);
      applyLanguage();
    });
  });
  applyLanguage();
}
